export default "__VITE_ASSET__BSdTlDen__"